import { Stack } from '@mui/material'
import { morphForWords } from 'components/shared/processes'
import { ILicenseItem } from 'models/IUserData'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import InfoChipItem from 'ui/InfoChipItem'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

interface ICardLicense {
	license: ILicenseItem
}
export const CardLicense = (props: ICardLicense) => {
	const { license } = props
	const daysUntilExpiration = moment(license.until_dt).diff(moment(), 'days')
	return (
		<CardStandart sx={{ p: '24px' }}>
			<Stack direction={'column'} gap={'16px'}>
				<InfoChipItem
					bgColor={
						daysUntilExpiration < 0
							? COLORS.error10
							: daysUntilExpiration < 30
								? COLORS.healthOpacity10
								: COLORS.successOpacity
					}
					label={
						daysUntilExpiration < 0
							? 'истекла'
							: `осталось ${daysUntilExpiration} ${morphForWords(
									daysUntilExpiration,
									['день', 'дня', 'дней'],
								)}`
					}
					labelColor={
						daysUntilExpiration < 0
							? COLORS.error
							: daysUntilExpiration < 30
								? COLORS.health
								: COLORS.success
					}
				/>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<TypographySecondary14>ПО</TypographySecondary14>
					<TypographyPrimary sx={{ textAlign: 'right' }}>
						{license.license_name?.toUpperCase()}
					</TypographyPrimary>
				</Stack>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<TypographySecondary14>Номер лицензии</TypographySecondary14>
					<TypographyPrimary sx={{ textAlign: 'right' }}>
						{license.license_num?.toUpperCase()}
					</TypographyPrimary>
				</Stack>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<TypographySecondary14>Срок лицензии</TypographySecondary14>
					<TypographyPrimary sx={{ textAlign: 'right' }}>
						{moment(license.start_dt).format('DD.MM.YYYY') +
							' - ' +
							moment(license.until_dt).format('DD.MM.YYYY')}
					</TypographyPrimary>
				</Stack>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<TypographySecondary14>Место внедрения</TypographySecondary14>
					<TypographyPrimary sx={{ textAlign: 'right' }}>
						{license.barn_title ? license.barn_title : '-'}
					</TypographyPrimary>
				</Stack>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
				>
					<TypographySecondary14>Аппаратный модуль</TypographySecondary14>
					<TypographyPrimary sx={{ textAlign: 'right' }}>
						{license.hardware_module
							? license.hardware_module.toUpperCase()
							: '-'}
					</TypographyPrimary>
				</Stack>
			</Stack>
		</CardStandart>
	)
}
